import React, { useEffect, useState } from 'react'

import { SALE_TIME_MODES, getSaleTimeMode, setSaleTimeMode, subscribeSaleTimeMode } from '../utils/saleTime'
import '../styles/SaleTimeModeToggle.css'

const TITLES = {
  UTC: 'Hora UTC',
  MADRID: 'Hora de Madrid (Europe/Madrid)',
  LOCAL: 'Hora local de cada máquina (zona horaria del contrato)',
}

// Hook: current sale time display mode, re-renders when it changes anywhere
export function useSaleTimeMode() {
  const [mode, setMode] = useState(getSaleTimeMode())
  useEffect(() => subscribeSaleTimeMode(setMode), [])
  return mode
}

// UTC / Madrid / Local switch for the home hourly chart (per-viewer preference)
export default function SaleTimeModeToggle({ className = '' }) {
  const mode = useSaleTimeMode()

  return (
    <div className={`stm-toggle ${className}`} role="group" aria-label="Zona horaria de las horas de venta" onClick={e => e.stopPropagation()}>
      <i className="fas fa-globe-europe stm-icon" title="Zona horaria de las horas de venta"></i>
      {SALE_TIME_MODES.map(m => (
        <button
          key={m.value}
          type="button"
          className={`stm-option${mode === m.value ? ' active' : ''}`}
          title={TITLES[m.value]}
          aria-pressed={mode === m.value}
          onClick={() => setSaleTimeMode(m.value)}
        >
          {m.label}
        </button>
      ))}
    </div>
  )
}
